<template>
  <div class="d d_xm detail">
    <div v-if="isadmin != '1'">
      <headers :goBack="goBack" />
    </div>
    <div class="reason" v-if="status == 2 && list.reason">
      未通过原因：{{ list.reason }}
    </div>

    <div class="info">
      <p>提交人：{{ userName }}</p>
      <!-- <p v-if="list.school">学 校： {{ list.school }}</p> -->
      <p>提交时间：{{ unixTimeToDateTime(time) }}</p>
    </div>
    <div id="iframe-container">
      <component
        :is="formComponent"
        v-if="formComponent"
        :list="list"
      />

      <iframe
        v-else
        id="iframeId"
        @load="loadFrame"
        :src="iframeUrl + '?headTop=true&isAdministrators=true&type=2&dataId=' + dataId"
      ></iframe>
    </div>
    <div class="ft ft_sh" v-if="currentUserDataStatus == 0 && isadmin != '1'">
      <div class="d f_opa">
        <label>操作：</label>
        <p @click="operation(1)">通过</p>
        <p @click="operation(2)">不通过</p>
      </div>
    </div>
    <div class="ft ft_sh" v-if="currentUserDataStatus == 1 && isadmin != '1'">
      <div class="d f_opa">
        <label>操作：</label>
        <p @click="operation(2)">不通过</p>
      </div>
    </div>

    <div class="ft ft_sh" v-if="currentUserDataStatus == 2 && isadmin != '1'">
      <div class="d f_opa">
        <label>操作：</label>
        <p @click="operation(1)">通过</p>
      </div>
    </div>

    <t-Message
      :visible="isVisible"
      :handler="handlerStatus"
      :handlerClose="handlerClose"
      placeholder="请输入原因"
      title="提示"
      cnt="确定要不通过此条内容吗？"
    ></t-Message>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted, getCurrentInstance, computed } from "vue";
import { useRoute, useRouter } from "vue-router";
import { setAuditData, getsubmitData } from "@/service/form";
import headers from "@/components/Header";
import form1 from "@/components/form/Form1";
import form2 from "@/components/form/Form2";
import form4 from "@/components/form/Form4";
import form5 from "@/components/form/Form5";
import form6 from "@/components/form/Form6";

import form8 from "@/components/form/Form8";
import form9 from "@/components/form/Form9";
import form10 from "@/components/form/Form10";
import form11 from "@/components/form/Form11";
import form12 from "@/components/form/Form12";

import tMessage from "@/components/InputMessage.vue";
import { getRadioValue, unixTimeToDateTime, tipsMsg } from "@/common/js";
import { formatIdByTxt } from "@/common/js";
import { sponsorTypes, activeThemes, activeTypes } from "@/common/js/field";
export default {
  name: "infoDetail",
  setup() {
    const route = useRoute();
    const router = useRouter();
    const { proxy } = getCurrentInstance();
    const state = reactive({
      isVisible: false,
      list: {},
      fieldInfo: {},
      showCalendar: false,
      currentUserDataStatus: -1,
      userName: "",
      time: null,
      formId: null,
      // 兼容后台查看
      isadmin: 0,
      status: -1,
      dataId: -1,
      iframeUrl: "",
    });

    const formComponent = computed(() => {
      const formMap = {
        2: "form1",
        3: "form2",
        4: "form4",
        5: "form4",
        6: "form5",
        7: "form6",
        32: "form6",
        37: "form8",
        38: "form9",
        39: "form10",
        40: "form11",
        41: "form12",
      };
      return formMap[state.formId] || null;
    });

    const fetchData = async () => {
      const { oid, formId, isadmin, status = -1, vueUrl } = route.query;
      const outsideIds = [9, 10, 11, 12, 22, 23, 24, 29];
      const isOutside = outsideIds.includes(Number(formId));

      state.isadmin = isadmin || 0;
      state.iframeUrl = vueUrl || "";
      state.status = status;
      state.formId = formId;

      proxy.$showLoading();

      try {
        const result = await getsubmitData({ dataId: oid, isadmin, isOutside });
        const { code, data } = result;

        if (code === 10000 && data) {
          state.dataId = data.id;
          let newObj = {};

          if (Number(formId) === 7 || data.formId === 32) {
            const itemsField = data.list.find((i) => i.fieldCode === "items");
            if (itemsField && itemsField.value) {
              const value = itemsField.value;
              value.forEach((item) => {
                item.activeThemesTxt = formatIdByTxt(activeThemes, item.activeTheme);
                item.activeType = formatIdByTxt(activeTypes, item.activeType);
                item.sponsorTypeTxt = formatIdByTxt(sponsorTypes, item.sponsorType);
                item.date = `${item.startDay}至${item.endDay}`;
              });
              newObj = { items: value };
            }
          } else {
            data.list.forEach((item) => {
              newObj[item.fieldCode] = item.value;
            });
          }

          state.list = newObj;

          // 如果是本地组件渲染，关闭 loading；如果是 iframe，则由 iframe 的 load 事件关闭
          if (formComponent.value) {
            proxy.$closeLoading();
          }
        }
      } catch (error) {
        console.error("fetchData error:", error);
        proxy.$closeLoading();
      }
    };

    onMounted(async () => {
      init();
      fetchData();
    });
    const init = async () => {
      const { username, time, status } = route.query;
      state.userName = username;
      state.time = time;
      state.currentUserDataStatus = status;
    };

    const onSubmit = async (values) => {
      console.log("修改", values);
      const { id, url } = route.query;
      if (id) {
        router.push({ path: "/info/add", query: { id, url, type: 2 } });
      }
    };
    // loadFrame函数是iframe加载完成后回调函数
    const loadFrame = () => {
      proxy.$closeLoading();
    };

    const goBack = () => {
      const { status } = route.query;
      router.push({ path: "/organization/auditor", query: { status } });
      // router.go(-1);
    };
    const handlerClose = () => {
      state.isVisible = false;
    };
    const handlerStatus = async (value) => {
      const { oid } = route.query;
      if (value == "") {
        tipsMsg("提示", "请填写不通过原因");
        return false;
      } else {
        setAuditDataFn(oid, 2, value);
      }
    };
    const setAuditDataFn = async (changeUser, status, value) => {
      let param = {
        dataIds: [changeUser],
        status,
      };
      if (status == 2) {
        param.reason = value;
      }
      const { code } = await setAuditData(param);
      if (code === 10000) {
        state.isVisible = false;
        router.go(-1);
      }
    };
    const operation = async (status) => {
      let msg = "通过";
      if (status == 2) {
        msg = "不通过";
      }
      let type = 1;
      if (status == 2) {
        type = 3;
      }
      if (status == 2) {
        state.isVisible = 2;
        return false;
      }

      proxy.$tipsMessage(
        true,
        type,
        "提示",
        `确定要${msg}此条内容吗？`,
        async () => {
          const { oid } = route.query;
          setAuditDataFn(oid, status);
          proxy.$tipsMessage(false);
        },
        true
      );
    };
    return {
      ...toRefs(state),
      formComponent,
      onSubmit,
      getRadioValue,
      goBack,
      operation,
      unixTimeToDateTime,
      handlerClose,
      setAuditDataFn,
      handlerStatus,
      loadFrame,
    };
  },
  components: {
    form1,
    form2,
    form5,
    form4,
    headers,
    tMessage,
    form6,
    form8,
    form9,
    form10,
    form11,
    form12
  },
};
</script>

<style lang="less" scoped>
@import "../../../common/style/mixin";
.detail {
  height: 100%;
  background: #fff;
  &-footer {
    position: fixed;
    bottom: 0;
    width: 100%;
    height: 50px; /* 底部高度 */
    line-height: 50px;
    color: @primary;
    font-size: 16px;
    background: #fff;
  }
  &-footer-update {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-left: 10px;
  }
  .van-button--round {
    border-radius: 0;
    height: 50px; /* 底部高度 */
    line-height: 50px;
    width: 100px;
  }
}
#iframe-container {
  height: 100%;
  width: 100%;
}
#iframe-container iframe {
  height: 100%;
  width: 100%;
}
.back_left {
  position: absolute;
  margin-top: 5px;
}
.f_opa {
  justify-content: center;
  align-items: center;
  display: flex;
}
.f_opa p {
  display: inline-block;
  color: #0e97f9;
  margin: 0 0.107rem;
}
.info {
  padding: 15px 20px;
}
.reason {
  font-size: 0.397rem;
  line-height: 1.4;
  color: #fd3535;
  vertical-align: middle;
  margin: 0.4rem;
  margin-bottom: 0;
}
#iframeId {
  // background: #f90;
  min-height: 500px;
  height: auto;
  border: none;
  overflow: auto;
}
</style>
